import ko from "@/translations/ko/common.json";
import en from "@/translations/en/common.json";
import retrunKO from "@/translations/ko/returnCode.json";
import retrunEN from "@/translations/en/returnCode.json";

export default {
  KO: { ...ko, ...retrunKO },
  EN: { ...en, ...retrunEN },
};
